import {Component, OnInit} from '@angular/core';
import {VehiclesService} from '../../../../../data/vehicles/vehicles.service';
import {VehicleCategoryModel} from '../../../../../shared/models/vehicle';
import {CardComponent} from '../../../../../shared/components/card/card.component';
import {CardContentRawDirective} from '../../../../../shared/components/card/card-content.directive';
import {Router} from '@angular/router';
import {RootRoute, SettingsRoute} from '../../../../../shared/models/angular-routing';
import {MatList, MatListItem, MatListItemMeta, MatListItemTitle} from '@angular/material/list';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatDialog} from '@angular/material/dialog';
import {DialogConfirmDeleteVehicleCategoryComponent} from '../dialogs-vehicle-group/vehicle-group-dialog-components';
import {firstValueFrom} from 'rxjs';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {ToastService} from '../../../../../shared/services/toast.service';

@Component({
  selector: 'app-manage-vehicle-groups',
  imports: [
    CardComponent,
    MatList,
    MatListItem,
    MatListItemTitle,
    MatListItemMeta,
    MatIconButton,
    MatIcon,
    MatProgressSpinner,
    CardContentRawDirective
  ],
  templateUrl: './manage-vehicle-groups.component.html',
  styleUrl: './manage-vehicle-groups.component.scss'
})
export class ManageVehicleGroupsComponent implements OnInit {

  groups: VehicleCategoryModel[] = [];
  isLoading = false;

  constructor(
    private readonly vehiclesService: VehiclesService,
    private readonly dialog: MatDialog,
    private readonly toastService: ToastService,
    private readonly router: Router,) {
  }

  ngOnInit() {
    this.reloadData();
  }

  reloadData() {
    this.isLoading = true;
    this.vehiclesService.getVehicleCategories().then(result => {
      this.groups = result;
    }).finally(() => {
      this.isLoading = false;
    })
  }

  goBack() {
    this.router.navigate(['/', RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES])
      .then();
  }

  deleteGroup(group: VehicleCategoryModel) {
    let ref = this.dialog.open(DialogConfirmDeleteVehicleCategoryComponent, {
      data: group
    });

    firstValueFrom(ref.afterClosed()).then(result => {
      if (result) {
        this.vehiclesService.deleteVehicleCategory(group.id).then(() => {
          this.reloadData();
          this.toastService.long('The group has been deleted');
        })
      }
    });
  }
}
